module.exports = angular.module('msi.payments.shippingService', []).name;

const inject = ['$injector'];

function ShippingService($injector) {
  this.getShippingConfig = function() {
    return $injector.has('externalShipping') ? $injector.get('externalShipping') : $injector.get('shippingConfig');
  };
}

ShippingService.$inject = inject;

angular.module(module.exports).service('shippingService', ShippingService);
